var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco17(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3275 0.570312C11.3493 0.570312 0.828125 11.0923 0.828125 24.07C0.828125 37.0477 11.3493 47.5706 24.3275 47.5706C37.3057 47.5706 47.8281 37.0484 47.8281 24.07C47.8281 11.0916 37.3057 0.570312 24.3275 0.570312ZM24.328 37.0662C22.6413 37.0662 21.2731 35.6993 21.2731 34.0114H27.3824C27.3827 35.6993 26.0147 37.0662 24.328 37.0662ZM34.6508 30.9482H34.65V30.948C34.65 32.0776 33.7346 32.152 32.6058 32.152H16.0498C14.9205 32.152 14.0059 32.0776 14.0059 30.948V30.7535C14.0059 29.9411 14.483 29.2455 15.1684 28.9156L15.8173 23.3142C15.8173 19.2136 18.7172 15.7911 22.5778 14.9836V12.809C22.5778 11.8424 23.3616 11.0586 24.3288 11.0586C25.2954 11.0586 26.0792 11.8424 26.0792 12.809V14.9837C29.9398 15.7911 32.8397 19.2133 32.8397 23.3144L33.4886 28.9165C34.1741 29.2469 34.6508 29.9413 34.6508 30.7536V30.9482Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco17);
export default __webpack_public_path__ + "static/media/ico-17.f90f97953a4ebc9616b19cd2bcb1a0cc.svg";
export { ForwardRef as ReactComponent };